export const ServiceTypes = [
  { value: 1, text: "Transfer" },
  { value: 2, text: "Hourly" }
];

export const RideTypeTypes = [
  { value: "B", text: "Business" },
  { value: "P", text: "Personal" },
  { value: "G", text: "Guest" },
  { value: "O", text: "Other" }
];

export const TaggingTypes = [
  { value: "Tariff", text: "Tariff" },
  { value: "Vehicle", text: "Vehicle" },
  { value: "Zone", text: "Zone" }
];

export const ServiceType = {
  AirportTransferText: "AirportTransfer",
  AirportTransferEnum: 1,
  RentalHourlyText: "Rental",
  RentalHourlyEnum: 2
};

export const AmountTypes = [
  { value: 1, text: "Flat" },
  { value: 2, text: "Percentage" }
];

export const DaysArray = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday"
];

export const AncillaryCalculationTypeArray = [
  { value: 1, text: "One Time Calculate" },
  { value: 2, text: "Per Day Calculate" }
];

export const AncillaryCalculationType = {
  OneTimeCalculate: 1,
  PerDayCalculate: 2
};

export const GeneralSurchargeType = {
  NightTime: 1,
  Weekend: 2,
  GarageTime: 3,
  Others: 4
};

export const DefaultTableObject = {
  keyword: "",
  totalPages: 1,
  totalRecords: 0,
  pageNumber: 1,
  pageSize: 25,
  pageSizes: [25, 50, 100],
  items: []
};

export const UserPermissionGroup = {
  AirportTransferReservation: "InquiryReservation",
  HourlyReservation: "InstantReservation",
  InquiryAvailability: "InquiryAvailability",
  InstantAvailability: "InstantAvailability"
};

export const WaitingTimeType = [
  { value: 1, text: "Airport Arrival" },
  { value: 2, text: "Non-Airport Arrival" },
  { value: 3, text: "Extra Stop" },
  { value: 4, text: "Extra Stop Waiting Time" }
];

export const ConversionFormula = {
  MultiplicationValue: "Multiplication",
  DivisionValue: "Multiplication"
};

export const Currencies = [
  { value: "AUD", text: "Australian Dollar" },
  { value: "CAD", text: "Canadian Dollar" },
  { value: "CHF", text: "Swiss Franc" },
  { value: "CNY", text: "China Yuan" },
  { value: "EUR", text: "Euro" },
  { value: "GBP", text: "British Pound" },
  { value: "HKD", text: "Hongkong Dollar" },
  { value: "JPY", text: "Japanese Yen" },
  { value: "NZD", text: "New Zealand Dollar" },
  { value: "SGD", text: "Singapore Dollar" },
  { value: "THB", text: "Thai Baht" },
  { value: "USD", text: "US Dollar" }
];

export const PreBookingItem = {
  baseLabel: "Base",
  markupLabel: "Markup",
  nightHourSurchargeLabel: "Morning/Night/Peak-Hour",
  peakPeriodSurchargeLabel: "Peak-Period Surcharge",
  weekendSurchargeLabel: "Weekend Surcharge"
};

export const PostBookingItem = {
  extraStopLabel: "Extra Stop",
  fareParkingLabel: "Parking Fare",
  fareTollLabel: "Toll Fare",
  noShowLabel: "No Show",
  waitingTimeLabel: "Waiting Time",
  overtimeLabel: "Overtime"
};

export const CurrencyFormat = [
  { Currency: "AED", DecimalPoint: 2, Format: "0,0.00" },
  { Currency: "ALL", DecimalPoint: 2, Format: "0,0.00" },
  { Currency: "AMD", DecimalPoint: 2, Format: "0,0.00" },
  { Currency: "ANG", DecimalPoint: 2, Format: "0,0.00" },
  { Currency: "AOA", DecimalPoint: 2, Format: "0,0.00" },
  { Currency: "ARS", DecimalPoint: 2, Format: "0,0.00" },
  { Currency: "AUD", DecimalPoint: 2, Format: "0,0.00" },
  { Currency: "AWG", DecimalPoint: 2, Format: "0,0.00" },
  { Currency: "AZN", DecimalPoint: 2, Format: "0,0.00" },
  { Currency: "BAM", DecimalPoint: 2, Format: "0,0.00" },
  { Currency: "BBD", DecimalPoint: 2, Format: "0,0.00" },
  { Currency: "BDT", DecimalPoint: 2, Format: "0,0.00" },
  { Currency: "BGN", DecimalPoint: 2, Format: "0,0.00" },
  { Currency: "BHD", DecimalPoint: 3, Format: "0,0.000" },
  { Currency: "BMD", DecimalPoint: 2, Format: "0,0.00" },
  { Currency: "BND", DecimalPoint: 2, Format: "0,0.00" },
  { Currency: "BOB", DecimalPoint: 2, Format: "0,0.00" },
  { Currency: "BRL", DecimalPoint: 2, Format: "0,0.00" },
  { Currency: "BSD", DecimalPoint: 2, Format: "0,0.00" },
  { Currency: "BWP", DecimalPoint: 2, Format: "0,0.00" },
  { Currency: "BYN", DecimalPoint: 2, Format: "0,0.00" },
  { Currency: "BZD", DecimalPoint: 2, Format: "0,0.00" },
  { Currency: "CAD", DecimalPoint: 2, Format: "0,0.00" },
  { Currency: "CHF", DecimalPoint: 2, Format: "0,0.00" },
  { Currency: "CLP", DecimalPoint: 2, Format: "0,0.00" },
  { Currency: "CNY", DecimalPoint: 2, Format: "0,0.00" },
  { Currency: "COP", DecimalPoint: 2, Format: "0,0.00" },
  { Currency: "CRC", DecimalPoint: 2, Format: "0,0.00" },
  { Currency: "CUP", DecimalPoint: 2, Format: "0,0.00" },
  { Currency: "CVE", DecimalPoint: 0, Format: "0,0" },
  { Currency: "CZK", DecimalPoint: 2, Format: "0,0.00" },
  { Currency: "DJF", DecimalPoint: 0, Format: "0,0" },
  { Currency: "DKK", DecimalPoint: 2, Format: "0,0.00" },
  { Currency: "DOP", DecimalPoint: 2, Format: "0,0.00" },
  { Currency: "DZD", DecimalPoint: 2, Format: "0,0.00" },
  { Currency: "EGP", DecimalPoint: 2, Format: "0,0.00" },
  { Currency: "ETB", DecimalPoint: 2, Format: "0,0.00" },
  { Currency: "EUR", DecimalPoint: 2, Format: "0,0.00" },
  { Currency: "FJD", DecimalPoint: 2, Format: "0,0.00" },
  { Currency: "FKP", DecimalPoint: 2, Format: "0,0.00" },
  { Currency: "GBP", DecimalPoint: 2, Format: "0,0.00" },
  { Currency: "GEL", DecimalPoint: 2, Format: "0,0.00" },
  { Currency: "GHS", DecimalPoint: 2, Format: "0,0.00" },
  { Currency: "GIP", DecimalPoint: 2, Format: "0,0.00" },
  { Currency: "GMD", DecimalPoint: 2, Format: "0,0.00" },
  { Currency: "GNF", DecimalPoint: 0, Format: "0,0" },
  { Currency: "GTQ", DecimalPoint: 2, Format: "0,0.00" },
  { Currency: "GYD", DecimalPoint: 2, Format: "0,0.00" },
  { Currency: "HKD", DecimalPoint: 2, Format: "0,0.00" },
  { Currency: "HNL", DecimalPoint: 2, Format: "0,0.00" },
  { Currency: "HTG", DecimalPoint: 2, Format: "0,0.00" },
  { Currency: "HUF", DecimalPoint: 2, Format: "0,0.00" },
  { Currency: "IDR", DecimalPoint: 0, Format: "0,0" },
  { Currency: "ILS", DecimalPoint: 2, Format: "0,0.00" },
  { Currency: "INR", DecimalPoint: 2, Format: "0,0.00" },
  { Currency: "IQD", DecimalPoint: 3, Format: "0,0.000" },
  { Currency: "ISK", DecimalPoint: 2, Format: "0,0.00" },
  { Currency: "JMD", DecimalPoint: 2, Format: "0,0.00" },
  { Currency: "JOD", DecimalPoint: 3, Format: "0,0.000" },
  { Currency: "JPY", DecimalPoint: 0, Format: "0,0" },
  { Currency: "KES", DecimalPoint: 2, Format: "0,0.00" },
  { Currency: "KGS", DecimalPoint: 2, Format: "0,0.00" },
  { Currency: "KHR", DecimalPoint: 2, Format: "0,0.00" },
  { Currency: "KMF", DecimalPoint: 0, Format: "0,0" },
  { Currency: "KRW", DecimalPoint: 0, Format: "0,0" },
  { Currency: "KWD", DecimalPoint: 3, Format: "0,0.000" },
  { Currency: "KYD", DecimalPoint: 2, Format: "0,0.00" },
  { Currency: "KZT", DecimalPoint: 2, Format: "0,0.00" },
  { Currency: "LAK", DecimalPoint: 2, Format: "0,0.00" },
  { Currency: "LBP", DecimalPoint: 2, Format: "0,0.00" },
  { Currency: "LKR", DecimalPoint: 2, Format: "0,0.00" },
  { Currency: "LYD", DecimalPoint: 3, Format: "0,0.000" },
  { Currency: "MAD", DecimalPoint: 2, Format: "0,0.00" },
  { Currency: "MDL", DecimalPoint: 2, Format: "0,0.00" },
  { Currency: "MKD", DecimalPoint: 2, Format: "0,0.00" },
  { Currency: "MMK", DecimalPoint: 2, Format: "0,0.00" },
  { Currency: "MNT", DecimalPoint: 2, Format: "0,0.00" },
  { Currency: "MOP", DecimalPoint: 2, Format: "0,0.00" },
  { Currency: "MRU", DecimalPoint: 2, Format: "0,0.00" },
  { Currency: "MUR", DecimalPoint: 2, Format: "0,0.00" },
  { Currency: "MVR", DecimalPoint: 2, Format: "0,0.00" },
  { Currency: "MWK", DecimalPoint: 2, Format: "0,0.00" },
  { Currency: "MXN", DecimalPoint: 2, Format: "0,0.00" },
  { Currency: "MYR", DecimalPoint: 2, Format: "0,0.00" },
  { Currency: "MZN", DecimalPoint: 2, Format: "0,0.00" },
  { Currency: "NAD", DecimalPoint: 2, Format: "0,0.00" },
  { Currency: "NGN", DecimalPoint: 2, Format: "0,0.00" },
  { Currency: "NIO", DecimalPoint: 2, Format: "0,0.00" },
  { Currency: "NOK", DecimalPoint: 2, Format: "0,0.00" },
  { Currency: "NPR", DecimalPoint: 2, Format: "0,0.00" },
  { Currency: "NZD", DecimalPoint: 2, Format: "0,0.00" },
  { Currency: "OMR", DecimalPoint: 3, Format: "0,0.000" },
  { Currency: "PAB", DecimalPoint: 2, Format: "0,0.00" },
  { Currency: "PEN", DecimalPoint: 2, Format: "0,0.00" },
  { Currency: "PGK", DecimalPoint: 2, Format: "0,0.00" },
  { Currency: "PHP", DecimalPoint: 2, Format: "0,0.00" },
  { Currency: "PKR", DecimalPoint: 2, Format: "0,0.00" },
  { Currency: "PLN", DecimalPoint: 2, Format: "0,0.00" },
  { Currency: "PYG", DecimalPoint: 0, Format: "0,0" },
  { Currency: "QAR", DecimalPoint: 2, Format: "0,0.00" },
  { Currency: "RON", DecimalPoint: 2, Format: "0,0.00" },
  { Currency: "RSD", DecimalPoint: 2, Format: "0,0.00" },
  { Currency: "RUB", DecimalPoint: 2, Format: "0,0.00" },
  { Currency: "RWF", DecimalPoint: 0, Format: "0,0" },
  { Currency: "SAR", DecimalPoint: 2, Format: "0,0.00" },
  { Currency: "SBD", DecimalPoint: 2, Format: "0,0.00" },
  { Currency: "SCR", DecimalPoint: 2, Format: "0,0.00" },
  { Currency: "SEK", DecimalPoint: 2, Format: "0,0.00" },
  { Currency: "SGD", DecimalPoint: 2, Format: "0,0.00" },
  { Currency: "SHP", DecimalPoint: 2, Format: "0,0.00" },
  { Currency: "SLE", DecimalPoint: 2, Format: "0,0.00" },
  { Currency: "SOS", DecimalPoint: 2, Format: "0,0.00" },
  { Currency: "SRD", DecimalPoint: 2, Format: "0,0.00" },
  { Currency: "STN", DecimalPoint: 2, Format: "0,0.00" },
  { Currency: "SVC", DecimalPoint: 2, Format: "0,0.00" },
  { Currency: "SZL", DecimalPoint: 2, Format: "0,0.00" },
  { Currency: "THB", DecimalPoint: 2, Format: "0,0.00" },
  { Currency: "TND", DecimalPoint: 3, Format: "0,0.000" },
  { Currency: "TOP", DecimalPoint: 2, Format: "0,0.00" },
  { Currency: "TRY", DecimalPoint: 2, Format: "0,0.00" },
  { Currency: "TTD", DecimalPoint: 2, Format: "0,0.00" },
  { Currency: "TWD", DecimalPoint: 2, Format: "0,0.00" },
  { Currency: "TZS", DecimalPoint: 2, Format: "0,0.00" },
  { Currency: "UAH", DecimalPoint: 2, Format: "0,0.00" },
  { Currency: "UGX", DecimalPoint: 0, Format: "0,0" },
  { Currency: "USD", DecimalPoint: 2, Format: "0,0.00" },
  { Currency: "UYU", DecimalPoint: 2, Format: "0,0.00" },
  { Currency: "UZS", DecimalPoint: 2, Format: "0,0.00" },
  { Currency: "VEF", DecimalPoint: 2, Format: "0,0.00" },
  { Currency: "VND", DecimalPoint: 0, Format: "0,0" },
  { Currency: "VUV", DecimalPoint: 0, Format: "0,0" },
  { Currency: "WST", DecimalPoint: 2, Format: "0,0.00" },
  { Currency: "XAF", DecimalPoint: 0, Format: "0,0" },
  { Currency: "XCD", DecimalPoint: 2, Format: "0,0.00" },
  { Currency: "XOF", DecimalPoint: 0, Format: "0,0" },
  { Currency: "XPF", DecimalPoint: 0, Format: "0,0" },
  { Currency: "YER", DecimalPoint: 2, Format: "0,0.00" },
  { Currency: "ZAR", DecimalPoint: 2, Format: "0,0.00" },
  { Currency: "ZMW", DecimalPoint: 2, Format: "0,0.00" }
];

export const UserType = {
  UnspecifiedLabel: "Unspecified",
  TenantUserLabel: "TenantUser",
  ProviderUserLabel: "ProviderUser",
  CorporateUserLabel: "CorporateUser"
};



// WEBPACK FOOTER //
// ./src/models/constants.js